import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import React from 'react';

// issue to consolidate modalPortal references
// https://alltrails.atlassian.net/browse/SVR-5120
// inspired by https://github.com/reactjs/react-modal
function PortalModal({ children, isOpen }) {
  return <>{isOpen && createPortal(children, global.document && global.document.getElementById('modalPortal'))}</>;
}

PortalModal.propTypes = {
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool.isRequired
};

export default PortalModal;
